exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nselect[data-v-150f099a],\nselect[data-v-150f099a]:hover {\n  border: 1px solid #6f3053;\n  border-radius: 3px;\n  margin-bottom: 20px;\n  font-size: 18px;\n  line-height: 20px;\n  color: black;\n  width: 100%;\n  padding: 14px 42px 14px 16px;\n  height: 50px;\n  background-position: right 11px center;\n  background-size: 20px 12px;\n  background-image: url(\"/img/Create Pickl/selectproductDropdown_icon.png\");\n  background-color: white;\n}\n", ""]);

// exports
